import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, InputBase, Typography } from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  Check as CheckIcon,
} from "@mui/icons-material";

const PDFEditorHeader = ({
  title,
  onTitleChange,
  onSave,
  onClose,
  loading,
  setOpenPreviewDialog,
}) => {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [draftTitle, setDraftTitle] = useState(title || "Untitled Form");

  useEffect(() => {
    setDraftTitle(title || "Untitled Form");
  }, [title]);

  const commitTitle = () => {
    const finalTitle = draftTitle?.trim() || "Untitled Form";
    onTitleChange?.(finalTitle);
    setDraftTitle(finalTitle);
    setIsEditingTitle(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        p: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}
      >
        {isEditingTitle ? (
          <InputBase
            value={draftTitle}
            onChange={(e) => setDraftTitle(e.target.value)}
            onBlur={commitTitle}
            onKeyDown={(e) => {
              if (e.key === "Enter") commitTitle();
              if (e.key === "Escape") {
                setDraftTitle(title || "Untitled Form");
                setIsEditingTitle(false);
              }
            }}
            autoFocus
            sx={{
              fontSize: "1.25rem",
              fontWeight: 600,
              borderBottom: "1px solid #1976d2",
              minWidth: 220,
            }}
          />
        ) : (
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title || "Untitled Form"}
          </Typography>
        )}

        <IconButton
          size="small"
          onClick={() =>
            isEditingTitle ? commitTitle() : setIsEditingTitle(true)
          }
        >
          {isEditingTitle ? (
            <CheckIcon fontSize="small" />
          ) : (
            <EditIcon fontSize="small" />
          )}
        </IconButton>
      </Box>

      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="contained"
          onClick={() => setOpenPreviewDialog(true)}
          disabled={loading}
        >
          Preview
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={loading}
          sx={{ width: "max-content" }}
        >
          Save Changes
        </Button>
        <IconButton onClick={onClose} disabled={loading}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PDFEditorHeader;
